export const STACK_SAMPLE_INTAKE_DEFAULT_SORT = { id: "code", desc: true };

/** @type {import('../lib/dataTable').DataTableColumn[]} */
export const STACK_SAMPLE_INTAKE_COLUMNS = [
  { id: "code", label: "Batch", accessorKey: "code", filterType: "text" },
  { id: "party_name", label: "Party", accessorKey: "party_name", filterType: "text" },
  {
    id: "intake_timing",
    label: "Timing",
    accessorKey: "intake_timing",
    filterType: "select",
    filterOptions: [
      { value: "", label: "All" },
      { value: "BEFORE_CONTRACT", label: "Before contract" },
      { value: "AFTER_CONTRACT", label: "After contract" },
    ],
    matchFilter: (row, value) => !value || row.intake_timing === value,
  },
  {
    id: "status",
    label: "Status",
    accessorKey: "status",
    filterType: "select",
    filterOptions: [
      { value: "", label: "All" },
      { value: "DRAFT", label: "Draft" },
      { value: "LAB_PENDING", label: "Lab pending" },
      { value: "LAB_DONE", label: "Lab done" },
      { value: "PENDING_APPROVAL", label: "Pending approval" },
      { value: "PARTIALLY_APPROVED", label: "Partially approved" },
      { value: "APPROVED", label: "Approved" },
      { value: "REJECTED", label: "Rejected" },
    ],
    matchFilter: (row, value) => !value || row.status === value,
  },
  {
    id: "stack_lines",
    label: "Stacks",
    accessor: (row) =>
      (row.stack_lines || [])
        .map((ln) => `${ln.sample_code} ${ln.stack_number} ${ln.quality}`)
        .join(" "),
    filterType: "text",
  },
];
